export default "__VITE_ASSET__1TB59gSr__"